import {
  SET_LOYALTY_TYPE,
  SET_CASHBACK_TYPE,
  TOGGLE_BOTTOM_SHEET,
  SET_PREV_CASHBACK_TYPE,

  // settings
  GET_BANNERS,
  SET_ITEMS_MENU,
  UPDATE_BONUS_DETAILS,
  SET_STORES_EXCLUDE_ITEMS,
  SET_STORES_MULTIPLE_BILL_ALERT,
  SET_STORES_CASHBACK_PERCENTAGE,
  SET_ACTIVE_STEP_FOR_FRD_NOTIFY,
  SET_ADVANCED_CASHBACK_SEED_DATA,
  SET_STORES_EXCLUDE_PAYMENT_TYPES,

  // loyalty data
  UPDATE_PREVIEW_DETAILS,
  SET_LOYALTY_DATA,
  RESET_LOYALTY,

  // insights
  GET_LOYALTY_INSIGHTS,
  GET_LOYALTY_PERF_INSIGHTS,
  GET_LOYALTY_ACTIVITY,
  GET_LOYALTY_TIER_INSIGHTS,
  GET_LOYALTY_SCOREBOARD,
  GET_LOYALTY_CUSTOMERS,
} from "../types";

const initialState = {
  isBottomSheet: false,

  selectedLoyaltyType: "",
  selectedCashbackType: "",

  banners: [],
  itemsMenu: [],
  defaultColors: {},
  advCbSeedData: [],
  industryRewards: [],

  bonusDetails: {},

  previewDetails: {},
  loyaltyData: {},

  storesForAlert: [],
  storesForExcludeItems: [],
  activeStepForFraudNotifi: 1,
  storesForCashbackPercentage: [],
  storesForExcludePaymentTypes: [],

  activity: {},
  customers: {},
  scoreBoard: {},
  loyaltyPerf: {},
  loyaltyInsights: {},
};

const user = (state = initialState, action) => {
  switch (action.type) {
    case SET_LOYALTY_TYPE:
      return {
        ...state,
        selectedLoyaltyType: action.payload,
      };
    case SET_CASHBACK_TYPE:
      return {
        ...state,
        selectedCashbackType: action.payload,
      };
    case SET_PREV_CASHBACK_TYPE:
      return {
        ...state,
        prevSelectedCashbackType: action.payload,
      };
    case TOGGLE_BOTTOM_SHEET:
      return {
        ...state,
        isBottomSheet: action.payload,
      };
    case SET_ACTIVE_STEP_FOR_FRD_NOTIFY:
      return {
        ...state,
        activeStepForFraudNotifi: action.payload,
      };
    case SET_STORES_MULTIPLE_BILL_ALERT:
      return {
        ...state,
        storesForAlert: action.payload,
      };
    case SET_STORES_EXCLUDE_ITEMS:
      return {
        ...state,
        storesForExcludeItems: action.payload,
      };
    case SET_STORES_EXCLUDE_PAYMENT_TYPES:
      return {
        ...state,
        storesForExcludePaymentTypes: action.payload,
      };
    case SET_STORES_CASHBACK_PERCENTAGE:
      return {
        ...state,
        storesForCashbackPercentage: action.payload,
      };
    case SET_LOYALTY_DATA:
      return {
        ...state,
        loyaltyData: action.payload,
      };
    case UPDATE_PREVIEW_DETAILS: {
      return {
        ...state,
        previewDetails: action.payload,
      };
    }
    case UPDATE_BONUS_DETAILS: {
      return {
        ...state,
        bonusDetails: action.payload,
      };
    }
    case GET_LOYALTY_INSIGHTS: {
      return {
        ...state,
        loyaltyInsights: action.payload,
      };
    }
    case GET_LOYALTY_PERF_INSIGHTS: {
      return {
        ...state,
        loyaltyPerf: action.payload,
      };
    }
    case GET_LOYALTY_ACTIVITY:
      return {
        ...state,
        activity: action.payload,
      };
    case GET_LOYALTY_TIER_INSIGHTS:
      return {
        ...state,
        loyaltyTierInsights: action.payload,
      };
    case GET_LOYALTY_SCOREBOARD:
      return {
        ...state,
        scoreBoard: action.payload,
      };
    case GET_LOYALTY_CUSTOMERS:
      return {
        ...state,
        customers: action.payload,
      };
    case GET_BANNERS: {
      return {
        ...state,
        banners: action.payload[0]?.banners,
        defaultColors: action.payload[0]?.color,
        industryRewards: action.payload[0]?.rewards,
      };
    }
    case SET_ADVANCED_CASHBACK_SEED_DATA: {
      return {
        ...state,
        advCbSeedData: action.payload,
      };
    }
    case SET_ITEMS_MENU: {
      return {
        ...state,
        itemsMenu: action.payload,
      };
    }
    case RESET_LOYALTY: {
      return initialState;
    }
    default:
      return state;
  }
};

export default user;
